import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const LOGIN_LOGS_REQUEST = 'FETCH_LOGIN_LOGS_REQUEST';
export const LOGIN_LOGS_FAILURE = 'FETCH_LOGIN_LOGS_FAILURE';
export const LOGIN_LOGS_SUCCESS = 'FETCH_LOGIN_LOGS_SUCCESS';

/**
 * Login history lives in the shared audit store: it is the SECURITY_EVENT
 * slice of the one timeline, not a table of its own. The scope is pinned
 * here so no caller can accidentally widen it.
 */
export const fetchLoginLogs = (filters = {}) => {
    return function(dispatch) {
        dispatch(fetchLoginLogsRequest());
        return axios(apiRequestOptions(apiPath.ENTITY_CHANGE_LOGS.LIST, {
            ...filters,
            entryType: 'security_event',
            // This resource pages at 50 by default; ask for the cap, because
            // this view sorts and pages what it was given on the client.
            itemsPerPage: 500,
            'order[changedAt]': 'desc',
        }))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchLoginLogsSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchLoginLogsFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchLoginLogsRequest = () => ({ type: LOGIN_LOGS_REQUEST });
const fetchLoginLogsFailure = (error) => ({ type: LOGIN_LOGS_FAILURE, error });
const fetchLoginLogsSuccess = (data) => ({ type: LOGIN_LOGS_SUCCESS, data });
